export const SET_PORTFOLIO = "SET_PORTFOLIO";
export const SET_TEMPLATES_DATA = "SET_TEMPLATES_DATA";
export const SET_ACTIVE_FIELDS = "SET_ACTIVE_FIELDS";
export const SET_DEFAULTS = "SET_DEFAULTS";
export const SET_FIELD_ITEM = "SET_FIELD_ITEM";
export const MOVE_FIELD_ITEM = "MOVE_FIELD_ITEM";
export const REMOVE_FIELD_ITEM = "REMOVE_FIELD_ITEM";
export const SET_PENDING_TEMPLATE_FIELD_OPTIONS = "SET_PENDING_TEMPLATE_FIELD_OPTIONS";
export const REMOVE_PENDING_TEMPLATE_FIELD_OPTIONS = "REMOVE_PENDING_TEMPLATE_FIELD_OPTIONS";
export const REPLACE_PENDING_TEMPLATE_FIELD_OPTIONS = "REPLACE_PENDING_TEMPLATE_FIELD_OPTIONS";
